<template>
  <v-row>
    <v-col cols="12" sm="6">
      <h2>Welcome to Sterling Lyon Pediatrics!</h2>
      <p>We are your centre for consultation and comprehensive medical care for infant, child and adolescent health.</p>
      <v-list dense>
        <v-subheader>Explore our Site</v-subheader>
        <v-list-item v-for="(item,i) in otherPages" :key="i" :to="item.path">
          {{item.name}}
        </v-list-item>
      </v-list>
    </v-col>
    <v-col cols="12" sm="6">
      <v-carousel
        cycle
        hide-delimiters
        show-arrows-on-hover
      >
        <v-carousel-item
          v-for="(image, i) in carouselImages"
          :key="i"
        >
          <v-img
            :alt='image.alt'
            :title='image.alt'
            :src='image.src'
          >
          </v-img>
        </v-carousel-item>
      </v-carousel>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      carouselImages: [
        { src: '/carousel/sterling lyon building.jpg', alt: 'Sterling Lyon Business Park' },
        { src: '/carousel/img_0006.jpg', alt: 'Waiting Room' },
        { src: '/carousel/img_0046.jpg', alt: 'Reception Desk' },
        { src: '/carousel/img_0103.jpg', alt: 'Doctor\'s Office' },
        { src: '/carousel/img_0310.jpg', alt: 'Examining Table' },
        { src: '/carousel/office.jpg', alt: 'Hallway' },
      ],
    };
  },

  computed: {
    otherPages() {
      return this.links.filter(l => l.name !== this.$route.name);
    },
  },

  props: ['links'],
};
</script>
